import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import React, { useState } from "react";
import Text from "../../components/Text";
import mut from "../../hooks/mut";

export default function ResolvedIssueDialog(props) {
  const { open, setOpen, issue, lesson, setLesson } = props;
    const [resolutionDescription, setResolutionDescription] = useState("")
    
    const resolve = async () => {
       let issuesDetail = await mut(
         "post",
         `/resolve-syllabus-issues/${lesson._id}/${issue._id}`,{resolutionDescription}
       );
        setLesson(prev => ({ ...prev, issuesDetail }))
        setOpen(false)
   }

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Resolved issue</DialogTitle>
          <DialogContent>
              <div className="text-xs text-cyan-700">Issue:</div>
              <div className="p-2">{issue.description}</div>
              <Text value={resolutionDescription} setValue={setResolutionDescription} label="What you did to resolve the issue" fullWidth size="small"/>
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
              <Button color="success" disabled={!resolutionDescription} onClick={resolve}>Go</Button>
      </DialogActions>
    </Dialog>
  );
}